import { useEffect } from "react"
import { useMsal } from "@azure/msal-react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { microsoftLogin } from "../../actions/usersActions"

export default function MicrosoftCallback() {

    const { accounts, instance } = useMsal()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {

        if (accounts.length > 0) {

            instance.acquireTokenSilent({
                account: accounts[0],
                scopes: ["User.Read"]
            })
            .then((response) => {
                dispatch(microsoftLogin(response.idToken))
                navigate("/")
            })
            .catch(err => console.error(err))
        }

    }, [accounts])

    return <h2>Procesando login Microsoft...</h2>
}